export enum PronunciationState {
  None = 0,
  Loading = 1 << 0,
  Initialized = 1 << 1,
  Saving = 1 << 2,
}
